import { render, staticRenderFns } from "./EpImage.vue?vue&type=template&id=b628b5d2&"
import script from "./EpImage.vue?vue&type=script&lang=js&"
export * from "./EpImage.vue?vue&type=script&lang=js&"
import style0 from "./EpImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports